import { whooshPrimitives } from "../../../../theme/colors/primitives";

type GetToggleSwitchTrackColorParams = {
  isChecked: boolean;
  isDisabled?: boolean;
  isHovered: boolean;
};

export const getToggleSwitchTrackColor = ({
  isChecked,
  isDisabled,
  isHovered,
}: GetToggleSwitchTrackColorParams) => {
  if (isDisabled) {
    return whooshPrimitives.grayscale[500];
  }

  if (isChecked) {
    return isHovered
      ? whooshPrimitives.status.success[700]
      : whooshPrimitives.main.primary[500];
  }

  return isHovered
    ? whooshPrimitives.grayscale[800]
    : whooshPrimitives.grayscale[700];
};
